import { gql } from '../gql';
import logWarningInDev from '../helpers/logWarningInDev';
logWarningInDev(true, `Importing fragments from '@jetshop/core/data/fragments.ts' is deprecated and will stop working in the next major release. Please import the .gql files from '@jetshop/core/data/fragments' instead, e.g.: '@jetshop/core/data/fragments/PriceFragment.gql'.`);
export const priceFragment = gql `
  fragment Price on Price {
    incVat
    exVat
    vat
  }
`;
export const badgeFragment = gql `
  fragment badgeFragment on ProductBadge {
    name
    url
    location
    style
    text
  }
`;
export const productPriceFragment = `
    price {
      ${priceFragment}
    }
    previousPrice {
      ${priceFragment}
    }
`;
export const breadcrumbFragment = gql `
  fragment Breadcrumb on Route {
    id
    path
    slug
    object {
      breadcrumbText
    }
  }
`;
export const routecrumbFragment = gql `
  fragment Routecrumb on Route {
    id
    path
    slug
    parents {
      id
      path
      slug
      object {
        breadcrumbText
      }
    }
  }
`;
export const productGridDetailsFragment = gql `
  fragment ProductGridDetails on Product {
    id
    articleNumber
    name
    subName
    shortDescription
    description
    mainHeader
    primaryRoute {
      ${routecrumbFragment}
    }
    ${productPriceFragment}
    images {
      alt
      title
      url
      sizes {
        url
        width
      }
    }
    badges {
      ${badgeFragment}
    }
  }
`;
export const categoryFragment = `
  id
  name
  content
  primaryRoute {
    ${routecrumbFragment}
  }
  images {
    width
    url
  }
`;
export const categoryDetailsFragment = gql `
  fragment CategoryDetails on Category {
    ${categoryFragment}
    products(first: $first, offset: $offset, filters: $filters, orderBy: $orderBy, orderByDirection: $orderByDirection) {
      sortOrders {
        text
        defaultDirection
        value
      }
      filters {
        id
        name
        __typename
        ... on ListFilter {
          items {
            text
            value
            resultCount
          }
        }
        ... on NumericRangeFilter {
          id
          min
          max
          name
        }
        ... on BooleanFilter {
          default
        }
        ... on MultiListFilter {
          lists {
            name
            items {
              value
              text
              resultCount
            }
          }
        }
      }
      totalResults
      result {
        ${productGridDetailsFragment}
      }
    }
  }
`;
export const stockStatusFragment = `
  stockStatus {
    buyable
    maxOrderQuantity
    stockDate
    stockNotificationEnabled
    text
  }
`;
export const productDetailsFragment = gql `
  fragment ProductDetails on Product {
    id
    articleNumber
    name
    subName
    shortDescription
    description
    ${productPriceFragment}
    ${stockStatusFragment}
    categories {
      name
      primaryRoute {
        path
      }
    }
    canonicalCategory {
      id
      name
    }
    variants {
      options {
        name
        values
      }
      values {
        values
        articleNumber
        ${productPriceFragment}
        ${stockStatusFragment}
      }
    }
    images {
      alt
      title
      url
      sizes {
        url
        width
      }
    }
    relatedProducts {
        ${productGridDetailsFragment}
    }
    customFields {
      key
      type
      title
      ... on CustomBoolField {
        boolValue: value
      }
      ... on CustomStringField {
        stringValue: value
      }
      ... on CustomHtmlField {
        htmlValue: value
      }
      ... on CustomListField {
        listValues: value
      }
      ... on CustomMultiLevelListField {
        items {
          id
          parentId
          title
          value
        }
      }
    }
    badges {
      ${badgeFragment}
    }
  }
`;
export const productPreviewFragment = gql `
  fragment ProductPreview on Product {
    id
    name
  }
`;
export const contentDetailsFragment = gql `
  fragment ContentDetails on Page {
    name
    id
    content
  }
`;
export const categoryDetailFragment = `
  id
  name
  level
  parentId
  hasSubcategories
  primaryRoute {
    id
    path
  }
`;
export const homeCategoriesFragment = gql `
  fragment HomeCategories on Category {
    ${categoryDetailFragment}
    subcategories {
      ${categoryDetailFragment}
      subcategories {
        ${categoryDetailFragment}
      }
    }
  }
`;
export const storesFragment = gql `
  query Stores {
    stores {
      city
      name
      id
    }
  }
`;
export const storeFragment = gql `
  fragment StoreDetails on Store {
    address1
    address2
    city
    contact
    description
    id
    name
    openHours
    other
    region
  }
`;
export const cartMutationFragment = gql `
  fragment CartMutationDetails on Cart {
    id
    totalQuantity
    productTotal {
      ${priceFragment}
    }
    productPreviousTotal {
      ${priceFragment}
    }
    discountTotal {
      ${priceFragment}
    }
    aggregatedDiscounts {
      name
      value {
        ${priceFragment}
      }
      description
      campaign {
        name
      }
    }
    items {
      id
      quantity
      discount {
        ${priceFragment}
      }
      total {
        ${priceFragment}
      }
    }
  }
`;
export const productMetadataFragment = gql `
  fragment ProductMetadata on Product {
    name
    articleNumber
    description
    primaryRoute {
      path
    }
    ${productPriceFragment}
    images {
      alt
      title
      url
      sizes {
        url
        width
      }
    }
    primaryRoute {
      id
      path
    }
    canonicalCategory {
      name
    }
  }
`;
export const cartFragment = gql `
  fragment CartDetails on Cart {
    id
    externalCheckoutUrl
    totalQuantity
    productTotal {
      ${priceFragment}
    }
    productPreviousTotal {
      ${priceFragment}
    }
    discountTotal {
      ${priceFragment}
    }
    aggregatedDiscounts {
      name
      value {
        ${priceFragment}
      }
      description
      campaign {
        name
      }
    }
    items {
      id
      quantity
      articleNumber
      subHeading
      variant {
        values
        images {
          url
          alt
        }
        articleNumber
        ${productPriceFragment}
      }
      discounts {
        name
        description
        value {
          ${priceFragment}
        }
      }
      discount {
        ${priceFragment}
      }
      total {
        ${priceFragment}
      }
      product {
        id
        name
        articleNumber
        ${productPriceFragment}
        primaryRoute {
          id
          path
        }
        images {
          alt
          title
          url
          sizes {
            url
            width
          }
        }
      }
    }
  }
`;
//# sourceMappingURL=fragments.js.map